<template>
  <div>
    <el-upload
      ref="upload"
      action=""
      :class="{ 'plus-hidden': fileList.length >= limit}"
      :accept="accept"
      :show-file-list="false"
      :file-list="fileList"
      :http-request="uploadSectionFile">
      <el-button
        size="small"
        type="primary">点击上传</el-button>
    </el-upload>
    <!-- <ul v-if="fileList.length"
      style="display: inline-block;line-height: 0;"
      class="el-upload-list el-upload-list--picture-card">
      <li tabindex="0"
        v-for="(item, index) in fileList"
        :key="index"
        class="el-upload-list__item is-success">
        <img :src="item.url"
          class="el-upload-list__item-thumbnail">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-delete">
            <i class="el-icon-delete"
              @click="handleRemove(index)"></i>
          </span>
        </span>
      </li>
    </ul> -->
    <ul
      v-if="fileList.length"
      class="el-upload-list el-upload-list--text">
      <li
        v-for="(item, index) in fileList"
        :key="index"
        tabindex="0"
        class="el-upload-list__item is-success">
        <a class="el-upload-list__item-name">
          <i class="el-icon-document"></i>
          {{ item.name }}
        </a>
        <label class="el-upload-list__item-status-label">
          <i class="el-icon-upload-success el-icon-circle-check"></i>
        </label>
        <i
          class="el-icon-close"
          @click="handleRemove(index)"></i>
      </li>
    </ul>
    <div
      class="el-upload__tip"
      style="margin-top:0">只能上传{{ accept }}文件，最多{{ limit }}个，且每个不超过2M</div>
  </div>
</template>

<script>
export default {
  name: 'UploadWithFile',
  components: {},
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    accept: {
      type: String
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  computed: {
    fileList: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    cropSubmit(file) {
      this.uploadFile(file.file)
    },
    uploadSectionFile({ file }) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!')
        return
      }
      this.uploadFile(file)
    },
    uploadFile(file) {
      const form = new FormData()
      form.append('file', file)
      this.$store.dispatch('wxaccount/uploadfile', {
        payload: form,
        success: res => {
          this.fileList.push({
            url: res.data.viewUrl + res.data.filepath,
            name: file.name
          })
        },
        fail: () => { }
      })
    },
    handleRemove(index) {
      this.fileList.splice(index, 1)
    }
  }
}
</script>
<style lang="stylus">
.plus-hidden {
  .el-upload {
    display: none;
  }
}
</style>
